<script setup lang="ts">
import type { AppDetailItem, AppDetailVariant } from './detailTypes'
import AppDetailList from './DetailList.vue'
import AppSectionHeading from './SectionHeading.vue'

defineOptions({ name: 'AppDetailSection' })

withDefaults(defineProps<{
  title: string
  description?: string
  icon?: string
  items: AppDetailItem[]
  columns?: 1 | 2
  emptyText?: string
  emptyTitle?: string
  labelWidth?: string | number
  variant?: AppDetailVariant
}>(), {
  columns: 2,
  emptyText: '-',
  labelWidth: '104px',
  variant: 'bordered',
})
</script>

<template>
  <section class="min-w-0">
    <AppSectionHeading :title="title" :description="description" :icon="icon">
      <template v-if="$slots.action" #action>
        <slot name="action" />
      </template>
    </AppSectionHeading>
    <AppDetailList
      v-if="items.length"
      :items="items"
      :columns="columns"
      :empty-text="emptyText"
      :label-width="labelWidth"
      :variant="variant"
    />
    <FaEmpty v-else :title="emptyTitle || '暂无详情数据'" class="py-6 md:py-6" />
    <div v-if="$slots.default" class="mt-3">
      <slot />
    </div>
  </section>
</template>
